import { libraryManagedConfig } from '../../config';
import * as types from '../constants';
import { buildBulkRequestPathParamsAndData, deselectAll } from '../productSelection/actions';

import { globalError, globalErrorResponse, showNotification, TYPE_WARNING } from '../notifications/actions';
import { failSelectionlists } from '../orderlist/actions';
import { AppDispatch, GetAppState } from '../index';
import i18n from '../../../i18n';
import { http } from '../../api/axios';

export function addToGroup(productGroupId: string, productId: string, onSuccess?: () => void) {
    return (dispatch: AppDispatch) => {
        http.put(
            libraryManagedConfig().endpointProductGroupBulkSource,
            { productIds: [productId] },
            {
                pathParams: { productGroupId, source: 'cc', kind: 'ids', action: 'copy' }
            }
        )
            .then(() => {
                dispatch(showNotification(i18n.t('marketing.productGroups.warnings.saveProductSuccessful')));
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch(error => dispatch(globalError(error)));
    };
}

export function addProductsToGroup({
    sourceProductGroupId,
    targetProductGroupId
}: {
    sourceProductGroupId?: string;
    targetProductGroupId: number;
}) {
    return (dispatch: AppDispatch, state: GetAppState) => {
        const endpoint = libraryManagedConfig().endpointProductGroupBulkSource;
        let requestdata;
        try {
            requestdata = buildBulkRequestPathParamsAndData(types.ACTION_COPY, 1, state, false);
        } catch (error) {
            dispatch(showNotification(i18n.t('marketing.productGroups.warnings.noSelectedProducts'), TYPE_WARNING));
            return;
        }
        const pathParams = requestdata.pathParams;
        pathParams.sourceId = sourceProductGroupId;
        pathParams.productGroupId = targetProductGroupId;
        const payload = requestdata.data;
        pathParams.source = 'productgroup';
        payload.sourceId = sourceProductGroupId;
        payload.source = 'productgroup';

        // workaround to enable quickfilter without error
        // connect handles quickfilters as collectionQuickfilters catman as quickFilters
        const hasQuickfilters = Object.prototype.hasOwnProperty.call(
            payload?.filterRequest ?? {},
            'collectionQuickfilters'
        );
        if (payload && payload.filterRequest && hasQuickfilters) {
            payload.filterRequest['quickfilters'] = payload.filterRequest['collectionQuickfilters'];
            delete payload.filterRequest['collectionQuickfilters'];
        }

        http.put(endpoint, payload, { pathParams })
            .then(() => {
                dispatch(deselectAll());
                dispatch(showNotification(i18n.t('marketing.productGroups.warnings.addSelectedProducts')));
            })
            .catch(error => dispatch(failSelectionlists(error, payload.source)));
    };
}

export function removeBulk(productGroupId: string, successCallback?: () => void) {
    return (dispatch: AppDispatch, state: GetAppState) => {
        const endpoint = libraryManagedConfig().endpointProductGroupBulk;
        let requestdata;
        try {
            requestdata = buildBulkRequestPathParamsAndData(types.ACTION_REMOVE, 0, state);
        } catch (error) {
            dispatch(showNotification(i18n.t('marketing.productGroups.warnings.noSelectedProducts'), TYPE_WARNING));
            return;
        }
        const pathParams = requestdata.pathParams;
        const payload = requestdata.data;

        pathParams.productGroupId = productGroupId;

        http.put(endpoint, payload, { pathParams })
            .then(() => {
                dispatch(showNotification(i18n.t('marketing.productGroups.warnings.removeSelectedProducts')));
                dispatch(deselectAll());
                successCallback && successCallback();
                return Promise.resolve();
            })
            .catch(error => {
                dispatch(globalErrorResponse(error));
                dispatch(deselectAll());
                return Promise.reject();
            });
    };
}
